import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="redirect"
export default class extends Controller {
  open(event) {
    window.location = event.detail.value;
  }
}
